import { useState } from "react";
import { LevelPreview } from "../../../components/blocksl/LevelPreview";
import { LevelDescriptionModal } from "../../../components/LevelDescriptionModal";
import { useWindowDimensions } from "../../../utils";

export const ProgramLevelsList = ({ levels = [] }) => {
  const { width: screenWidth } = useWindowDimensions();
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedSummary, setSelectedSummary] = useState("");
  const [showLevelDescription, setShowLevelDescription] = useState(false);

  const openLevelDescription = (level, summary) => {
    setSelectedSummary(summary);
    setSelectedLevel(level);
    setShowLevelDescription(true);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: screenWidth > 900 ? (screenWidth > 1400 ? 30 : 16) : 10,
        }}
      >
        {levels.map((level) => (
          <LevelPreview
            key={level.id}
            levelData={level}
            openLevelDescription={openLevelDescription}
          />
        ))}
      </div>
      <LevelDescriptionModal
        summary={selectedSummary}
        level={selectedLevel}
        isOpen={showLevelDescription}
        closeModalCallback={() => setShowLevelDescription(false)}
      />
    </>
  );
};
